var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolioBalance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45455 12.0909C1.05455 12.0909 0.712242 11.9486 0.427636 11.664C0.142546 11.3789 0 11.0363 0 10.6363V1.90907C0 1.50907 0.142546 1.16677 0.427636 0.882165C0.712242 0.597074 1.05455 0.454529 1.45455 0.454529H13.0909C13.4909 0.454529 13.8335 0.597074 14.1185 0.882165C14.4032 1.16677 14.5455 1.50907 14.5455 1.90907V6.27271H1.45455V10.6363H8.72727V12.0909H1.45455ZM1.45455 3.36362H13.0909V1.90907H1.45455V3.36362ZM12.3636 13.5454V11.3636H10.1818V9.90907H12.3636V7.72726H13.8182V9.90907H16V11.3636H13.8182V13.5454H12.3636ZM1.45455 10.6363V1.90907V10.6363Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioBalance);
export default __webpack_public_path__ + "static/media/portfolioBalance.b83d14009b42c1b8e9243210ddda9604.svg";
export { ForwardRef as ReactComponent };